<template>
    <div class="popup">
      <div v-if="title" class="popup_text">
        <div  v-if="title" class="popup_title">
            {{title}}
        </div>
        <div class="popup_subTitle" v-if="subTitle">
          {{subTitle}}
        </div>
      </div>
        <slot name="fields"></slot>

      <div class="popup_buttons">
          <slot name="buttons"></slot>
      </div>
    </div>
</template>

<script>
    export default {
        props: ['title','subTitle','buttonOkText'],
        data() {
            return {

            };
        },
        methods: {

        }
    };
</script>
